const Breadcrumb = (props) => {
  return (
    <div className="breadcrumb">
      <div className="container">
        <h1 className="text-center">{props.title}</h1>
      </div>
    </div>
  )
}

export default Breadcrumb;